/* src/app/shared/components/form-controls/ag-time/ag-time.component.scss */
input[type=time]::-webkit-calendar-picker-indicator {
  display: none;
}
input::-webkit-datetime-edit:focus {
  background-color: red;
  color: white;
  outline: none;
}
.ag-form-control {
  min-width: 110px;
}
.time-container {
  width: 100%;
  display: flex;
}
.time-container .grey-separator {
  border-left: 1px solid #c8c7cc;
  height: 100%;
  width: 12px;
}
.time-container img {
  padding-right: 8px;
  width: 24px;
}
/*# sourceMappingURL=ag-time.component.css.map */
